import styled from 'styled-components';
interface LankSelectProps {
  isSelected?: boolean;
}
interface ButtonProps {
  isActive: boolean;
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const ListContainer = styled.div`
  width: 100%;
`;

const ListTop = styled.div`
  width: 100%;
  padding: 32px 0 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 18px;
  font-weight: 700;
  color: #171e26;
`;
const SortBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;
const SortButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 30, 38, 0.78);
`;

const ArrowContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 5px;
`;

const ArrowUp = styled.div<ButtonProps>`
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid
    ${({ isActive }) => (isActive ? '#FA4032' : 'rgba(23, 30, 38, 0.40)')};
`;

const ArrowDown = styled.div<ButtonProps>`
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid
    ${({ isActive }) => (isActive ? '#008AFF' : 'rgba(23, 30, 38, 0.40)')};
  margin-top: 2px;
`;
const ListBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const ListHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  background-color: #f7f8f9;
`;
const ListHeaderItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: rgba(23, 30, 38, 0.56);
  flex-wrap: wrap;
`;

const List = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ListRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px 16px;
  border-bottom: 1px solid rgba(23, 30, 38, 0.1);
  cursor: pointer;
`;
const ItemDetailBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const ItemDetailTextBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 30, 38, 0.78);
`;
const Address = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #171e26;
`;

const TagBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 6px;
  flex-wrap: wrap;
`;

const CaseNumberBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 30, 38, 0.56);
`;
const UseState = styled.span`
  color: #008aff;
  margin-top: 4px;
`;

const PriceBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  align-items: flex-end;
`;

const PriceRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
`;
const PriceTag = styled.span`
  width: 25px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`;
const ProgressStatusBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #222;
  span {
    text-align: center;
  }
`;
const TextRed = styled.span`
  color: #fa4032;
`;
const TextGray = styled.span`
  color: rgba(55, 56, 60, 0.61);
`;
const CountNumber = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
`;

const CardBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 24px;
  column-gap: 16px;
`;

const Card = styled.div`
  width: 288px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #e5e8ea;
`;
const ImageBox = styled.div`
  width: 100%;
  max-width: 900px;
  height: 178px;
  position: relative;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
`;
const ItemImg = styled.img`
  width: 100%;
  height: 100%;
`;
const DutDateBox = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  padding: 0 8px;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.75);
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
  color: white;
  div {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 145%; /* 20.3px */
    letter-spacing: -0.28px;
  }
  span {
    color: #bababa;
    font-family: 'Spoqa Han Sans Neo';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 145%; /* 17.4px */
    letter-spacing: -0.24px;
  }
`;
const TypelTag = styled.span`
  width: 42px;
  height: 24px;
  border-radius: 999px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;

const InfoBox = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: #fff;
`;
const InfoSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: flex-start;
  align-items: flex-start;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
  color: rgba(23, 30, 38, 0.56);
`;
const InfoTopRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
const InfoTopRow02 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  span {
    font-family: 'Spoqa Han Sans Neo';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 145%; /* 17.4px */
    letter-spacing: -0.24px;
    color: rgba(55, 56, 60, 0.61);
  }
`;
const InfoTopRow03 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const Seperator = styled.span`
  width: 1px;
  height: 12px;
  background-color: rgba(23, 30, 38, 0.56);
`;
const CardAddress = styled.div`
  width: 100%;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
  color: #171e26;
`;
const AppraisalPrice = styled.span`
  color: rgba(23, 30, 38, 0.78);
`;
const LowestPrice = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
  color: #008aff;
`;

const ViewGrayText = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: #fa4032fa;
  white-space: wrap;
`;

const CategoryAndViewBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: absolute;
  top: 0;
  right: 0;
`;

const CategoryAndView = styled.div`
  padding: 4px 8px;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: white;
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover > span {
    display: block;
  }
`;

const Tooltip = styled.span`
  position: absolute;
  top: -32px;
  right: 50%;
  transform: translateX(50%);
  padding: 4px 8px;
  background-color: #2a3746;
  border-radius: 4px;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: white;
  white-space: nowrap;
  display: none;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: #2a3746 transparent transparent transparent;
  }
`;

const InterestBox = styled.div`
  width: 100%;
  padding: 6px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  background-color: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  color: #616161;
  position: relative;
`;

const Rating = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const RatingText = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
`;

const Nodata = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  color: #616161;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
`;
const MemoBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

const MoreText = styled.button`
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.28);
  background: none;
  border: none;
  cursor: pointer;
  border: none;
  background: none;
  white-space: nowrap;
  margin-left: 4px;
`;

const EditBox = styled.div`
  width: 180px;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 31px;
  right: 0;
  border-radius: 16px;
  background-color: #fff;
  box-shadow:
    0px 2px 8px 0px rgba(0, 0, 0, 0.12),
    0px 1px 4px 0px rgba(0, 0, 0, 0.08),
    0px 0px 1px 0px rgba(0, 0, 0, 0.08);
  z-index: 999;
`;
const EditBoxRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;

const Statustag01 = styled.div`
  font-weight: 500;
  color: #bababa;
`;
const Statustag02 = styled.div`
  font-weight: 700;
  color: #fff;
`;

const SelectBox = styled.div`
  width: 118px;
`;

const LankSelect = styled.div<LankSelectProps>`
  display: flex;
  flex-direction: row;
  padding: 6px 8px 6px 6px;
  gap: 8px;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;

  &:hover {
    background: rgba(2, 32, 71, 0.05);
  }
  span {
    color: ${({ isSelected }) =>
      isSelected ? 'rgba(0, 12, 30, 0.80)' : 'rgba(3, 18, 40, 0.7)'};
    font-size: 14px;
    font-weight: 500;
    line-height: 145%; /* 20.3px */
    letter-spacing: -0.28px;
  }

  img {
    width: 16px;
    height: 16px;
  }
`;
const WinLable = styled.div`
  display: flex;
  padding: 2px 5px;
  justify-content: center;
  align-items: center;
  color: #bc9313;
  background: url(/assets/images/game/win_label_count.svg) no-repeat center;
  background-size: cover;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 19.5px */
  letter-spacing: -0.26px;
  width: 90px;
`;
const WinLableWrap = styled.div`
  color: #616161;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const ListCardContentBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
  gap: 16px;
`;
const CardTextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const CardImgBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
`;

const Tag = styled.span`
  width: 42px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  background: #ffdbd6;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #d84836;
`;

const CardCategory = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 700;
  color: #008aff;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CardTitle = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  color: #171e26;
  line-height: 150%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const CardPrice = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 15px;
  font-weight: 500;
  color: #333d4b;
  strong {
    font-weight: 700;
  }
`;

const Status = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  color: rgba(55, 56, 60, 0.61);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
  strong {
    color: #222;
  }
`;
const BidPrice = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 15px;
  font-weight: 500;
  color: #008aff;
  strong {
    font-weight: 700;
  }
`;

const CardDateBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const HashTagWrapper = styled.div`
  width: 220px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  flex-wrap: wrap;
  margin-top: 4px;
`;
const TagText = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
  padding: 4px 8px;
  border-radius: 4px;
  background-color: rgba(112, 115, 124, 0.08);
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const BidTag = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #f45551;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: #ffefef;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const BidTag02 = styled.span`
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  background-color: rgba(112, 115, 124, 0.08);
  color: #222;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const BidTag03 = styled.span`
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: rgba(112, 115, 124, 0.08);
  color: rgba(55, 56, 60, 0.61);
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const ViewCount = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  color: rgba(55, 56, 60, 0.61);
`;

const ItemInfoBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 30, 38, 0.56);
  padding-bottom: 8px;
`;
const ItemTypeChip = styled.span`
  display: flex;
  padding: 2px 8px;
  align-items: center;
  gap: 2px;
  border-radius: 4px;
  background: #008aff;
  color: #fff;

  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;
const ListCardContentBoxWrap = styled.div`
  padding: 16px 0;
  border-bottom: 1px solid rgba(23, 30, 38, 0.1);
`;
const SelectBoxWrap = styled.div`
  margin-bottom: 20px;
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  gap: 12px;
`;
export const s = {
  Container,
  ListContainer,
  ListTop,
  SortBox,
  SortButton,
  ArrowContainer,
  ArrowUp,
  ArrowDown,
  ListBox,
  ListHeader,
  ListHeaderItem,
  List,
  ListRow,
  ItemDetailBox,
  ItemDetailTextBox,
  Address,
  TagBox,
  Tag,
  CaseNumberBox,
  UseState,
  PriceBox,
  PriceRow,
  PriceTag,
  ProgressStatusBox,
  TextRed,
  TextGray,
  CountNumber,
  CardBox,
  Card,
  ImageBox,
  ItemImg,
  DutDateBox,
  TypelTag,
  InfoBox,
  InfoSection,
  InfoTopRow,
  InfoTopRow02,
  InfoTopRow03,
  Seperator,
  AppraisalPrice,
  LowestPrice,
  CardAddress,
  ViewGrayText,
  CategoryAndView,
  CategoryAndViewBox,
  TooltipWrapper,
  Tooltip,
  InterestBox,
  Rating,
  RatingText,
  Nodata,
  MemoBox,
  MoreText,
  EditBox,
  EditBoxRow,
  Status,
  Statustag01,
  Statustag02,
  SelectBox,
  SelectBoxWrap,
  LankSelect,
  WinLable,
  WinLableWrap,
  ListCardContentBox,
  ListCardContentBoxWrap,
  CardTextBox,
  CardImgBox,
  CardCategory,
  CardTitle,
  CardPrice,
  CardDateBox,
  HashTagWrapper,
  TagText,
  BidPrice,
  BidTag,
  BidTag02,
  BidTag03,
  ViewCount,
  ItemInfoBox,
  ItemTypeChip,
};
